import { SymbologyType } from "../../types/SymbologyType";

export function mapBarcodeFormatToSymbologyType(
  format: string | undefined
): SymbologyType {
  switch (format) {
    case "itf":
      return "ITF";
    case "data_matrix":
      return "DATAMATRIX";
    case "ean_13":
      return "EAN13";
    case "qr_code":
      return "QR_CODE";
    default:
      return format === "UNKNOWN"
        ? "UNKNOWN"
        : ((format ? format.toUpperCase() : "UNKNOWN") as SymbologyType);
  }
}
